<!-- 払い戻しボタン-->
<template>
  <li>
    <a @click="goToBookRefund">
      {{ $t("MyTicketTicketing.refund") }}
    </a>
  </li>
</template>

<script>
export default {
  name: "BFaceRefundButton",
  methods: {
    // 返金画面へ
    goToBookRefund() {
      this.$router.push({
        name: "BookRefund",
        params: {
          book_group_id: this.$route.params.book_group_id,
          book_id: this.$route.params.book_id,
        },
        query: { language: this.$store.getters["common/lang"] },
      });
    },
  },
};
</script>
